import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { isBrand, ProductsPage, type Brand } from '@/modules/products/public';

export const Route = createFileRoute('/_aberto/catalogo')({
  validateSearch: z.object({
    // Marca desconhecida na URL cai em "todas", em vez de erro.
    marca: z
      .string()
      .optional()
      .catch(undefined)
      .transform((v): Brand | undefined => (isBrand(v) ? v : undefined)),
    favoritos: z.boolean().optional().catch(undefined),
    produto: z.string().optional().catch(undefined),
  }),
  component: function CatalogRoute() {
    const { marca, favoritos, produto } = Route.useSearch();
    return <ProductsPage view={{ brand: marca, favorites: favoritos, product: produto }} />;
  },
});
